import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {Button, Form, Input, InputGroup} from 'reactstrap';
import { finishRegistration, isTokenValid } from 'utils/api/authApi';
import { connect } from 'react-redux';
import { login, logoutWithoutRedirect } from 'redux/modules/auth/action';
import momentTZ from 'moment-timezone';
import {useHistory} from 'react-router-dom';
import './style.scss';
import SpinnerButton from 'components/SpinnerButton';

const FinishRegistrationPage = (props) => {
    let history = useHistory();

    const [passwordFirst, setFirstPassword] = useState('');
    const [passwordSecond, setSecondPassword] = useState('');
    const [loading, handleLoading] = useState(false);
    const [userName, setUserName] = useState('');
    const [accountName, setAccountName] = useState('');
    const [isSingleUser, setIsSingleUser] = useState(true);
    const [checkingToken, setCheckingToken] = useState(true);

    useEffect(() => {
        checkToken();
    }, [])

    const checkToken = async() => {
        try {
            const href = window.location.href;
            const count = href.indexOf('token=');
            const token = href.substring(count).replace('token=', '');
            let tokenCheck = await isTokenValid(token);
            if(!tokenCheck.content.token) {
                // setTokenInvalid(true);
                history.push('/link-expired');
            }
            setCheckingToken(false);
        } catch(err) {
            console.log(err);
            // setCheckingToken(false);
            history.push('/404')
        }
    };

    const validation = (value, type) => {
        if (value.split('')[0] === ' ' || value.split('')[value.length - 1] === ' ') {
            return false;
        }

        if (type === 'first') {
            setFirstPassword(value);
        } else {
            setSecondPassword(value);
        }
    };

    const getBrowserTimezone = () => {
        return momentTZ.tz.guess();
    }

    const handleSubmit = async () => {
        const href = window.location.href;
        const count = href.indexOf('token=');
        const token = href.substring(count).replace('token=', '');
        const timezone = getBrowserTimezone();

        const params = {
            isCreatedAccount: false,
            name: userName,
            accountName,
            isSingleUser,
            token,
            plainPassword: {
                first: passwordFirst,
                second: passwordSecond,
            },
            timezone: timezone ? timezone : null,
        };

        try {
            handleLoading(true);
            const user = await finishRegistration(params);
            await props.login(user.content.email, passwordFirst);
            //await props.setPermissions();
            history.push('/');
            handleLoading(false);
        } catch (e) {
            handleLoading(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
            }
            throw e.message;
        }
    };

    if(checkingToken) return null;
    return (
        <div className="finish_reg-container flex-centered">
            <h3 style={{ fontSize: '32px' }}>
                Complete Registration
            </h3>
            <div className="authorization-container">
                <InputGroup style={{ paddingLeft: '20px', marginBottom: '0.5rem' }}>
                    <Input type="radio" checked={isSingleUser} onClick={() => setIsSingleUser(true)} />{' '}Single User
                </InputGroup>
                <InputGroup className="mb-4" style={{ paddingLeft: '20px', marginBottom: '1.5rem' }}>
                    <Input type="radio" checked={!isSingleUser} onClick={() => setIsSingleUser(false)} />{' '}Organization
                </InputGroup>
                {!isSingleUser && 
                    <div>
                        <h3 style={{ fontSize: '22px', marginBottom: '12px' }}>
                            Organization info
                        </h3>
                        <InputGroup style={{ marginBottom: '1.5rem' }}>
                            <div className="input-group-prepend">
                                <span style={{ width: '40px' }} className="input-group-text">
                                    <i className="fas fa-building" />
                                </span>
                            </div>
                            <Input 
                                type="text" 
                                placeholder="Organization name" 
                                value={accountName} 
                                onChange={(e) => setAccountName(e.target.value)} 
                            />
                        </InputGroup>
                        <h3 style={{ fontSize: '22px', marginBottom: '12px' }}>
                            User info
                        </h3>
                    </div>
                }
                <InputGroup  style={{ marginBottom: '16px' }}>
                    <div className="input-group-prepend">
                        <span style={{ width: '40px' }} className="input-group-text">
                            <i className="fas fa-user" />
                        </span>
                    </div>
                    <Input 
                        type="text" 
                        placeholder="Full name" 
                        value={userName} 
                        onChange={(e) => setUserName(e.target.value)} 
                    />
                </InputGroup>
                <InputGroup style={{ marginBottom: '16px' }}>
                    <div className="input-group-prepend">
                        <span style={{ width: '40px' }} className="input-group-text">
                            <i className="fas fa-unlock-alt" />
                        </span>
                    </div>
                    <Input type="password" placeholder="Password" value={passwordFirst} onChange={(e) => validation(e.target.value, 'first')} />
                </InputGroup>
                <InputGroup className="mb-3">
                    <div className="input-group-prepend">
                        <span style={{ width: '40px' }} className="input-group-text">
                            <i className="fas fa-unlock-alt" />
                        </span>
                    </div>
                    <Input
                        type="password"
                        placeholder="Confirm Password"
                        onChange={(e) => validation(e.target.value, 'second')}
                        value={passwordSecond}
                        className="form-control"
                        aria-describedby="basic-addon1"
                    />
                </InputGroup>
                <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'start' }}>
                    <SpinnerButton
                        title="Sign In"
                        submitting={loading}
                        onClick={handleSubmit}
                    />
                    {/*{loading ? (*/}
                    {/*    <div style={{ display: 'flex', justifyContent: 'center' }}>*/}
                    {/*        <i className="fa fa-spinner fa-spin" />*/}
                    {/*    </div>*/}
                    {/*) : (*/}
                    {/*    <Input*/}
                    {/*        disabled={*/}
                    {/*            passwordFirst === '' || */}
                    {/*            passwordSecond === '' || */}
                    {/*            passwordFirst !== passwordSecond || */}
                    {/*            userName.trim() === '' || */}
                    {/*            (!isSingleUser && accountName.trim() === '')*/}
                    {/*        }*/}
                    {/*        type="Submit"*/}
                    {/*        value="Sign in"*/}
                    {/*        className="btn calltoaction-button"*/}
                    {/*    />*/}
                    {/*)}*/}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
    { login, logoutWithoutRedirect }
)(FinishRegistrationPage);

